import React, { Component } from "react";
import { message, Button, Modal, Input } from "antd";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import classnames from "classnames";
import CloudFlyerAPI from "../../../api/CloudFlyerAPI";
import { refresh_profile } from "../../../actions/auth";
import BillingForm from "../../../components/Billing/BillingForm";

import "./styles.scss";

class PlanDetails extends Component {
  constructor() {
    super();

    this.state = {
      current_plan: { handle: "CloudFlyer-free" }, //'CloudFlyer-free', //25tb-CloudFlyer-media-management
      selected_plan: { handle: "CloudFlyer-free" },
      loading: true,
      pay_cycle: "monthly",
      billing_info: {},
      plans: [],
      contact_us_visible: false,
      enterprise_business_req: ""
    };
  }

  componentDidMount() {
    this.refresh_current_subscription();
  }

  refresh_current_subscription = () => {
    let $this = this;
    this.setState({ loading: true });

    CloudFlyerAPI.billing
      .packages()
      .then(res =>
        $this.setState({
          plans: ((res||{}).data||{}).packages.map(pkg => {
            pkg.description = pkg.description
              ? pkg.description.split("\n")
              : [];
            return pkg;
          }),
          loading: false
        })
      )
      .then(CloudFlyerAPI.billing.billing_info)
      .then(res => {
        let current_plan = ($this.state.plans.filter(
          p => p.handle === (((res||{}).data||{}).billing_info || {}).plan
        ) || [])[0];
        $this.setState({
          current_plan,
          selected_plan: current_plan,
          billing_info: ((res||{}).data||{}).billing_info
        });
      })
      .then($this.props.refresh_profile(true))
      .catch(err => {
        $this.setState({ loading: false });
        console.error(err);
        message.error(err.message);
      });
  };

  subscribe_to_plan = plan => {
    let $this = this;

    if (this.state.current_plan.order > plan.order) {
      return Modal.info({
        title: "Downgrading your billing plan",
        content: (
          <div>
            <p>
              Please contact us at{" "}
              <a href="mailto:support@CloudFlyer.com">support@CloudFlyer.com</a>
              <br />
              for our team to review your request.
              <br />
              We promise to get back to you quickly!
            </p>
          </div>
        ),
        className: "info-content"
      });
    }

    if (!plan.handle)
      return this.setState({ contact_us_visible: true, selected_plan: plan });

    let subscribe = () =>
      Modal.confirm({
        title: "Do you Want to subscribe to " + plan.title + " plan ?",
        okText: "Subscribe",
        destroyOnClose: true,
        onOk() {
          $this.setState({ loading: true });
          CloudFlyerAPI.billing
            .changePlan(plan.handle, $this.state.billing_info.subscription_id)
            .then(() => {
              message.success("Subscribed to " + plan.title + " successfully.");
              $this.setState({ loading: false });
            })
            .then($this.refresh_current_subscription)
            .then(() => {
              refresh_profile(true);
            })
            .catch(err => {
              message.error(err.message);
            })
            .finally(() => {
              $this.setState(
                { loading: false },
                $this.refresh_current_subscription
              );
            });
        }
      });

    if (!this.props.user.has_billing_info)
      return this.billing_form.open(subscription => {
        $this.props.refresh_profile();
        if (subscription) subscribe();
      });
    subscribe();
  };

  on_contact_us = (plan, enterprise_business_req) => {
    let $this = this;

    $this.setState({ sending: true });
    CloudFlyerAPI.billing
      .request_quote(plan.id, enterprise_business_req)
      .then(() => {
        $this.setState({ sending: false, contact_us_visible: false });
        message.success("Your message is sent successfully.");
      })
      .catch(err => {
        $this.setState({ sending: false });
        message.error(err.message);
      });
  };

  contact_us_cancel = () => {
    this.setState({ contact_us_visible: !this.state.contact_us_visible });
  };

  on_input_change = e => {
    const { name, value } = e.target || e || {};
    this.setState({ ...this.state, ...{ [name]: value } });
  };

  render() {
    const {
      plans,
      current_plan: { handle } = {},
      selected_plan,
      enterprise_business_req
    } = this.state;

    return (
      <div className="plans">
        {plans.map((plan, i) => (
          <div
            key={i}
            className={classnames({
              "price-card": true,
              current: handle === plan.handle
            })}
          >
            <div className={"heading"}>
              <span>{plan.title}</span>
            </div>

            <div className="inner">
              {plan.handle && (
                <div className="price">
                  <h1 className="label">
                    <span className="currency-symbol">
                      {plan.subscription_fee_monthly > 0 ? "$" : ""}
                    </span>
                    <span className="cost">
                      {plan.subscription_fee_monthly > 0
                        ? plan.subscription_fee_monthly
                        : "Free!"}
                    </span>
                  </h1>

                  <p className="text-smaller">{plan.sub_title}</p>
                </div>
              )}
              <p className="text-smaller ui-text-left content--us">
                {plan.pre_description}
              </p>

              <ul className="ul-checked">
                {(plan.description || []).map((benefit, i) => (
                  <li key={i}>{benefit}</li>
                ))}
              </ul>
            </div>

            <Button
              onClick={() => this.subscribe_to_plan(plan)}
              disabled={handle === plan.handle}
            >
              {handle === plan.handle ? "Current Plan" : plan.action_text}
            </Button>
          </div>
        ))}

        <Modal
          className={"modal-contact-us"}
          //title    = 'Contact Us'
          visible={this.state.contact_us_visible}
          onOk={() =>
            this.on_contact_us(selected_plan, enterprise_business_req)
          }
          onCancel={this.contact_us_cancel}
        >
          <div className={"user-input"}>
            <label>
              Tell us about your custom business requirements, we will be back
              to you with a free quote.
            </label>
            <Input.TextArea
              placeholder="Your business requirements"
              name="enterprise_business_req"
              value={enterprise_business_req}
              className={classnames({ required: !enterprise_business_req })}
              onChange={this.on_input_change}
              autosize={{ minRows: 4, maxRows: 10 }}
              autoFocus
            />
          </div>
        </Modal>

        <BillingForm
          user={this.props.user}
          refresh={this.props.refresh_profile}
          ref={form => (this.billing_form = form)}
        />
      </div>
    );
  }
}

export default withRouter(
  connect(
    ({ auth: { user } }) => ({ user }),
    dispatch => bindActionCreators({ refresh_profile, dispatch }, dispatch)
  )(PlanDetails)
);
